const PrivacyPolicyPage = () => (
  <div className="mx-auto max-w-2xl space-y-6" data-testid="privacy-policy-page">
    <h2 className="text-2xl font-semibold" data-testid="privacy-policy-title">
      PRIVACY POLICY (YOPINION)
    </h2>
    <div className="space-y-6 text-sm leading-relaxed text-muted-foreground" data-testid="privacy-policy-content">
      <p>Effective Date: Last updated: May 2026</p>
      <p>
        Yopinion ("we", "our", "us") respects your privacy. This Privacy Policy explains how we
        collect, use, and protect your information when you use our platform.
      </p>

      <div>
        <p className="font-medium text-foreground">1. Information We Collect</p>
        <p className="mt-2 font-medium text-foreground/80">a. Information you provide</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Name, username, email</li>
          <li>Profile information</li>
          <li>Polls you create</li>
          <li>Votes, comments, interactions</li>
        </ul>
        <p className="mt-2 font-medium text-foreground/80">b. Automatically collected</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Device information</li>
          <li>IP address</li>
          <li>Usage data (how you interact with polls)</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">2. How We Use Your Information</p>
        <p className="mt-1">We use your data to:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Provide and improve the platform</li>
          <li>Show poll results and insights</li>
          <li>Personalize your experience</li>
          <li>Prevent misuse and ensure safety</li>
          <li>Communicate updates or changes</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">3. Public Nature of Content</p>
        <p className="mt-1">Yopinion is a public opinion platform.</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Polls and results may be visible to other users</li>
          <li>Your activity may be associated with your profile</li>
          <li>Avoid sharing sensitive personal information</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">4. Data Sharing</p>
        <p className="mt-1">We do not sell your personal data.</p>
        <p className="mt-1">We may share data with:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Service providers (hosting, analytics)</li>
          <li>Legal authorities if required by law</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">5. Data Security</p>
        <p className="mt-1">
          We take reasonable measures to protect your data. However, no system is completely secure.
        </p>
      </div>

      <div>
        <p className="font-medium text-foreground">6. Your Choices</p>
        <p className="mt-1">You can:</p>
        <ul className="mt-1 list-disc pl-5 space-y-1">
          <li>Update or delete your account</li>
          <li>Control what you share</li>
          <li>Contact us for data-related requests</li>
        </ul>
      </div>

      <div>
        <p className="font-medium text-foreground">7. Children's Privacy</p>
        <p className="mt-1">Yopinion is not intended for users under 13.</p>
      </div>

      <div>
        <p className="font-medium text-foreground">8. Changes to Policy</p>
        <p className="mt-1">We may update this policy. Continued use means you accept changes.</p>
      </div>

      <div>
        <p className="font-medium text-foreground">9. Contact</p>
        <p className="mt-1">For questions: yopinion.social@gmail.com</p>
      </div>
    </div>
  </div>
);

export default PrivacyPolicyPage;
